const e = {
  name: "MinusSmall",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7 11H17V13H7V11Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as MinusSmall
};
